import {Injectable} from '@angular/core';
import {Observable, of, Subject} from 'rxjs';
import {Building} from '../model/building';
import {ApiRoutes} from '../../../config/api-routes';
import {HttpClient} from '@angular/common/http';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class BuildingsService {

  private buildings: Building[];
  private buildingsObs: Observable<Building[]>;
  private buildings$: Subject<Building[]> = new Subject<Building[]>();

  constructor(private httpClient: HttpClient, private routes: ApiRoutes) {}

  public getBuildings(): Observable<Building[]> {
    if (this.buildings != null) {
      return of(this.buildings);
    } else {
      if (this.buildingsObs == null) {
        this.buildingsObs = this.getBuildingsFromServer();
        this.buildingsObs.subscribe(b => {
          this.buildings = b;
          this.buildings$.next(this.buildings);
        });
      }
      return this.buildings$;
    }
  }

  private getBuildingsFromServer(): Observable<Building[]> {
    return this.httpClient.get<Building[]>(this.routes.BUILDINGS).pipe(
      catchError(() => of([]))
    );
  }

  public getBuildingsForInterventionTeam(interventionTeamId: string) {
    const url = ApiRoutes.getRouteWithInjectedParams(
      this.routes.BUILDINGS_FOR_INTERVENTION_TEAM,
      [interventionTeamId]
    );

    return this.httpClient.get<Building[]>(url)
      .pipe(
        catchError(() => of([]))
      );
  }
}
